export default class Employee{

    employeeList : any;

    constructor() {
        this.employeeList = this.createEmployeeList()
    }


    private createEmployeeList() {
        const tileData = [
            {
                img: './images/dummy-person-image.jpg',
                title: 'Rainer Mehele',
                position: "Geschäftsleitung",
                tel: "  +43-5576-72397-71",
                mobile: "  +43-664-33 88 567",
                mail: "   rainer.mehele@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Barbara Psaier',
                position: "Buchhaltung",
                tel: "  +43-5576-72397-0",
                mobile: "",
                mail: "   office@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Markus Rebhandl',
                position: "Ersatzteillager",
                tel: "  +43-5576-72397-73",
                mobile: "",
                mail: "   logistik@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Raphael Volger',
                position: "Ersatzteillager",
                tel: "  +43-5576-72397-73",
                mobile: "",
                mail: "   logistik@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Wolfgang Rüdisser',
                position: "Ersatzteillager",
                tel: "  +43-5576-72397-73",
                mobile: "",
                mail: "   logistik@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Stefan Mehele',
                position: "Werkstatt/Service/Pickerl",
                tel: "  +43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Dietmar Summer',
                position: "Werkstatt/Service/Pickerl",
                tel: "  ++43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Jakob Maissen',
                position: "Werkstatt/Service/Pickerl",
                tel: "  ++43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Erich Moosbrugger',
                position: "Werkstatt/Service/Pickerl",
                tel: "  ++43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },{
                img: './images/dummy-person-image.jpg',
                title: 'Lorenz Resch',
                position: "Werkstatt/Service/Pickerl",
                tel: "  ++43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },{
                img: './images/dummy-person-image.jpg',
                title: 'Jan Erhard',
                position: "Werkstatt/Service/Pickerl",
                tel: "  ++43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Christian Meyer',
                position: "Werkstatt/Service/Pickerl",
                tel: "  ++43-5576-72397-74",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Christoph Burtscher',
                position: "Service am Hof",
                tel: "  ++43-650-5106494",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },
            {
                img: './images/dummy-person-image.jpg',
                title: 'Jürgen Fenkart',
                position: "Service am Hof",
                tel: "  ++43-650-5106494",
                mobile: "",
                mail: "   werkstatt@mehele.at"
            },


        ];

        return tileData;
    }
}